import { IonLabel } from '@ionic/react';
import { ReactElement, useCallback, useState } from 'react';
import { Team, useListTeamsQuery } from '../../api/graphql/generated';
import i18n from '../../i18n';
import { useBeaconRouter } from '../../route/route.hooks';
import { IonItem } from '../ionic/IonItem';
import { ObjectList, RowRenderer } from '../object/object-list';
import { ActiveFilterPopoverContent } from '../ui/searchbar/active-filter-popover-content';
import { SearchbarPopoverChildrenProps } from '../ui/searchbar/searchbar';

const TenantTeams = (): ReactElement => {
  const { builder } = useBeaconRouter();
  const [showActive, setShowActive] = useState<boolean>(true);

  const filterPopoverContent = (props: SearchbarPopoverChildrenProps) => {
    return (
      <ActiveFilterPopoverContent
        showActive={showActive}
        onActiveChange={(active) => {
          setShowActive(active);
          // eslint-disable-next-line react/prop-types
          props.close();
        }}
      />
    );
  };

  const rowRenderer = useCallback<RowRenderer<Team>>(
    ({ item }) => {
      return (
        <IonItem
          className={item.active ? undefined : 'disabled-user'}
          key={item.id}
          routerLink={builder.getTeamSetupRoute(item.id)}
        >
          <IonLabel>
            <h2>{item.name}</h2>
          </IonLabel>
          {!item.active && (
            <IonLabel slot="end" className="ion-hide-sm-down">
              <p>{i18n.t('common:inactive')}</p>
            </IonLabel>
          )}
        </IonItem>
      );
    },
    [builder]
  );

  return (
    <ObjectList
      query={{
        useQuery: useListTeamsQuery,
        input: { active: showActive },
        queryOptions: {
          fetchPolicy: 'cache-and-network',
          nextFetchPolicy: 'cache-first',
        },
      }}
      filterPopoverContent={filterPopoverContent}
      showFilterIndicator={!showActive}
      noResults={i18n.t('common:no_results_found')}
      rowRenderer={rowRenderer}
    />
  );
};

export { TenantTeams };
